import React from 'react'
import PropTypes from 'prop-types'
import {FormattedMessage, useIntl} from 'react-intl'
import {useHistory} from 'react-router-dom'
import {Button, Divider, Flex, Text, useDisclosure, useMultiStyleConfig} from '@chakra-ui/react'
import Breadcrumb from '../../../components/breadcrumb'
import Search from '../../../components/search'
import ProductCodeModal from './product-code-modal'
import {GoBackIcon} from '../../../components/icons'
import {CAT_MENU_DEFAULT_ROOT_CATEGORY} from '@salesforce/retail-react-app/app/constants'
import SanitizedHtml from '../../../components/html-sanitizer'

const ManualsPageHeader = ({
    categoryId,
    setProductQuery,
    setShowResult,
    noResults,
    currentCategory = '',
}) => {
    const styles = useMultiStyleConfig('Manuals')
    const history = useHistory()
    const {isOpen, onOpen, onClose} = useDisclosure()
    const {formatMessage} = useIntl()

    return (
        <Flex {...styles.pageInnerContainer} data-testid="manuals-page-header">
            <Flex {...styles.breadcrumbContainer}>
                <Breadcrumb
                    categories={[
                        {id: '', name: 'Return to homepage'},
                        {id: 'InstructionManuals', name: 'Instruction Manuals'},
                    ]}
                />
            </Flex>
            {categoryId !== CAT_MENU_DEFAULT_ROOT_CATEGORY && (
                <Flex {...styles.goBackButtonContainer}>
                    <Button
                        onClick={() => {
                            setShowResult(false)
                            history.goBack()
                        }}
                        leftIcon={<GoBackIcon />}
                        {...styles.goBackButton}
                        data-testid="go-back-button"
                    >
                        {/* Label is placeholder for now */}
                        <FormattedMessage
                            defaultMessage="Go back"
                            id="manuals-page.go-back-button"
                        />
                    </Button>
                </Flex>
            )}
            <Flex {...styles.headerContentContainer}>
                {currentCategory !== '' && currentCategory !== 'root' ? (
                    <SanitizedHtml
                        as={Text}
                        html={`<h1>${currentCategory}</h1>`}
                        sanitize={true}
                        {...styles.headerTitle}
                    />
                ) : (
                    <Text {...styles.headerTitle} as="h1">
                        <FormattedMessage
                            defaultMessage="Instruction Manuals"
                            id="manuals-page.header-title"
                        />
                    </Text>
                )}
                <Divider {...styles.manualsDivider} />
                <Text {...styles.headerSubtitle}>
                    {noResults ? (
                        <FormattedMessage
                            defaultMessage="Sorry"
                            id="manuals-page.header-apology-subtitle"
                        />
                    ) : (
                        <FormattedMessage
                            defaultMessage="Find manuals by product"
                            id="manuals-page.header-subtitle"
                        />
                    )}
                </Text>
                <Flex {...styles.searchContainer}>
                    <Search
                        searchInputPlaceholder={
                            <FormattedMessage defaultMessage="Search" id="global.search" />
                        }
                        setShowProductGrid={setShowResult}
                        setProductQuery={setProductQuery}
                        isManualsPageSearch
                        shouldRemoveLabel
                        showSpellingMessage={noResults}
                    />
                    <Text
                        {...styles.headerFindProductNumberLabel}
                        onClick={onOpen}
                        tabIndex={0}
                        aria-label={formatMessage({
                            id: 'manuals-page.header-find-product-number-label',
                            defaultMessage: 'Where to find your product number',
                        })}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault()
                                onOpen()
                            }
                        }}
                        data-testid="find-product-number-label"
                    >
                        <FormattedMessage
                            defaultMessage="Where to find your product number"
                            id="manuals-page.header-find-product-number-label"
                        />
                    </Text>
                </Flex>
                {/* {noResults && (
                    <Text {...styles.noResultsText} data-testid="no-results-suggestion">
                        <FormattedMessage
                            defaultMessage="Check your spelling or try an alternative term"
                            id="manuals-page.header.no-results-text"
                        />
                    </Text>
                )} */}
            </Flex>
            {isOpen && <ProductCodeModal isOpen={isOpen} onClose={onClose} />}
        </Flex>
    )
}

ManualsPageHeader.propTypes = {
    categoryId: PropTypes.string,
    setProductQuery: PropTypes.func,
    setShowResult: PropTypes.func,
    noResults: PropTypes.bool,
    currentCategory: PropTypes.string,
}

export default ManualsPageHeader
